import Dashboard from "views/Dashboard/Dashboard.js";
import BMS from "views/Apps/Apps";
import LoginPage from "views/Pages/LoginPage.js";
import CrearPolos from "views/Polos/crearPolo.js";
import PoloDetails from "views/Polos/poloDetails.js";
import PoloEdit from "views/Polos/editPolo.js";
import CambiarPass from "views/User/cambiarPass.js";

// @material-ui/icons
import Apps from "@material-ui/icons/Apps";
import DashboardIcon from "@material-ui/icons/Dashboard";
import Image from "@material-ui/icons/Image";

var dashRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    rtlName: "لوحة القيادة",
    icon: DashboardIcon,
    component: Dashboard,
    layout: "/admin",
  },
  
  {
    collapse: true,
    invisible: true,
    name: "Pages",
    rtlName: "صفحات",
    icon: Image,
    state: "pageCollapse",
    views: [
      {
        path: "/login-page",
        name: "Login Page",
        rtlName: "هعذاتسجيل الدخول",
        mini: "L",
        rtlMini: "هعذا",
        component: LoginPage,
        layout: "/auth",
      },
    ],
  },
  {
    privacidad: true,
    path: "/crearpolo",
    name: "Crear Polos",
    mini: "B",
    rtlMini: "ب",
    component: CrearPolos,
    layout: "/admin",
  },
  {
    invisible: true,
    privacidad: true,
    path: "/apps",
    name: "Aplicaciones DMS",
    rtlName: "لوحة القيادة",
    icon: Apps,
    component: BMS,
    layout: "/admin",
  },
  {
    invisible: true,
    path: "/polo/:codigo/:zona",
    name: "Polo",
    mini: "P",
    rtlMini: "ب",
    component: PoloDetails,
    layout: "/admin",
  },
  {
    invisible: true,
    path: "/editar/:codigo/:zona",
    name: "Polo",
    mini: "P",
    rtlMini: "ب",
    component: PoloEdit,
    layout: "/admin",
  },
  {
    privacidad: true,
    // invisible: true,
    path: "/cambiar_pass",
    name: "Cambiar contraseña",
    rtlName: "لوحة القيادة",
    mini: "CP",
    component: CambiarPass,
    layout: "/admin",
  },
];

export default dashRoutes;
